import React, {ReactNode, useRef} from 'react';
import {constant} from 'lodash/fp';

import {PopupBackground} from '/component/partial/PopupBackground';

import {usePopupProvider} from './PopupProvider.hook';

export const PopupContext = React.createContext<{
  showPopup: () => void;
  hidePopup: () => void;
} | null>(null);

interface PopupProviderProps {
  children: ReactNode;
}

export const PopupProvider: React.FC<PopupProviderProps> = ({
  children = null,
}) => {
  const {
    interactionPropsRef,
    modalState,
    hidePopup,
    showPopup,
    onAnimationComplete,
    contentPropsRef,
    contentRef,
  } = usePopupProvider();

  const contextValue = useRef({showPopup, hidePopup}).current;

  const PopupContent = contentRef.current || constant(null);

  return (
    <PopupContext.Provider value={contextValue}>
      {children}
      <PopupBackground
        {...interactionPropsRef.current}
        modalState={modalState}
        hidePopup={hidePopup}
        onAnimationComplete={onAnimationComplete}>
        <PopupContent {...contentPropsRef.current} />
      </PopupBackground>
    </PopupContext.Provider>
  );
};
